import React from 'react';
import {OrbitComponent} from "../../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IGameContextViewModel
} from "../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameDetailHistoryHeaderBarComponent} from "../../../game-detail-history-header-bar.component";
import {BottomSessionBox} from "./boxes/bottom-session.box";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../../../../../common/const/responsible-gaming";
import {
    ResponsibleGamingButtonsGermanyComponent
} from "../../../../../../responsible-gambling/responsible-gaming-buttons/regulations/germany/responsible-gaming-buttons-germany.component";
import {
    GameDetailHistoryHeaderBarTopRightSectionBox
} from "../../../boxes/top-section/right/game-detail-history-header-bar-top-right-section.box";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {
    GameHeaderBarCloseGameButtonComponent
} from "../../../../common/parts/close-game-button/game-header-bar-close-game-button.component";

export const GermanyGameDetailHistoryMobileHeaderBarComponent = observer(
    class GermanyGameDetailHistoryMobileHeaderBarComponent extends OrbitComponent<{gameContext: IGameContextViewModel}> {
        private _renderBottomSection = () => {
            return (
                <BottomSessionBox>
                    <ResponsibleGamingButtonsGermanyComponent placement={GermanyResponsibleGamingButtonPlacement.inDetailedHistory}/>
                </BottomSessionBox>
            )
        }

        private _renderTopRightSection = () => {
            return (
                <GameDetailHistoryHeaderBarTopRightSectionBox>
                    <ResponsibleGamingButtonsGermanyComponent placement={GermanyResponsibleGamingButtonPlacement.inDetailedHistory}/>
                    <BlankHorizontalSeparatorBox multiplier={2}/>
                    <GameHeaderBarCloseGameButtonComponent/>
                </GameDetailHistoryHeaderBarTopRightSectionBox>
            );
        }

        render() {
            return (
                <GameDetailHistoryHeaderBarComponent gameContext={this.props.gameContext} renderTopRightSection={this._renderTopRightSection}/>
            );
        }
    }
);